import { createReducer } from 'redux-starter-kit';
import {
  login,
  loginSuccess,
  logout,
  redirectTo,
  register,
  registerSuccess,
  initForgotPassword,
  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetPassword,
  resetPasswordSuccess,
  resetPasswordFailure
} from 'actions/auth';

export default createReducer(
  {
    token: null,
    rememberMe: false,
    isAuthenticated: false,
    isAuthenticating: false,
    isRegistering: false,
    isResettingPassword: false,
    resetPasswordTokenSent: false,
    isPasswordReset: false
  },
  {
    [redirectTo]: (state, action) => ({
      ...state,
      redirectTo: action.payload
    }),
    [login]: (state, action) => ({ ...state, isAuthenticating: true }),
    [loginSuccess]: (state, action) => ({
      ...state,
      token: action.payload.token,
      rememberMe: action.payload.rememberMe,
      isAuthenticated: true,
      isAuthenticating: false
    }),
    [register]: (state, action) => ({ ...state, isRegistering: true }),
    [registerSuccess]: (state, action) => ({
      ...state,
      token: action.payload,
      isAuthenticated: true,
      isRegistering: false
    }),
    [logout]: (state, action) => ({
      ...state,
      token: null,
      isAuthenticated: false,
      isAuthenticating: false,
      isRegistering: false,
      rememberMe: false
    }),
    [initForgotPassword]: state => ({
      ...state,
      isResettingPassword: false,
      resetPasswordTokenSent: false,
      isPasswordReset: false
    }),
    [forgotPassword]: state => ({
      ...state,
      isResettingPassword: true
    }),
    [forgotPasswordSuccess]: state => ({
      ...state,
      isResettingPassword: false,
      resetPasswordTokenSent: true
    }),
    [forgotPasswordFailure]: state => ({
      ...state,
      isResettingPassword: false
    }),
    [resetPassword]: state => ({
      ...state,
      isResettingPassword: true
    }),
    [resetPasswordSuccess]: state => ({
      ...state,
      isResettingPassword: false,
      isPasswordReset: true
    }),
    [resetPasswordFailure]: state => ({
      ...state,
      isResettingPassword: false
    })
  }
);
